import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { json } from 'express';
import { NgxSpinnerService } from 'ngx-spinner';
import { AuthConfig, AuthService, ResponseObject } from 'src/app/Services/auth.service';
import { NotificationsService } from 'src/app/Services/shared/notifications.service';
import { StripeService } from 'src/app/Services/stripe.service';
import { NotificationTypes } from 'src/app/app.enums';
import { AppSettings } from 'src/app/app.settings';
import { TranslocoService } from '@jsverse/transloco';

@Component({
    selector: 'stripe-connect',
    templateUrl: './stripe-connect.component.html',
    standalone: false
})
export class StripeConnectComponent implements OnInit {
    public stripeCheckout = true
    public isAuthenticated = false;
    public authConfig!: AuthConfig;
    public isCheckoutSuccess: boolean = false;

    public ngOnInit(): void {
        this.isAuthenticated = this.authService.isAuthenticated();
        this.authConfig = this.authService.getAuthConfig();

        // this.router.navigate(['/']).then((_)=>{
        // if (isPlatformBrowser(this.platformId)) {
        //         localStorage.setItem(AppSettings.ON_STRIPE_CHECKOUT_SUCCESS, JSON.stringify(this.stripeCheckout));
        //         window.location.reload();
        //     }
        // });

        this.activatedRoute.queryParams.subscribe((params) => {
            if (params['session_id']) {
                this.spinnerService.show();
                this.stripeService.checkoutCompleted(params['session_id']).subscribe((response: ResponseObject) => {
                    if (response.Success) {
                        console.log(response.Success)
                        this.isCheckoutSuccess = true;
                        //reload the window once so the new updated access token takes effect
                        this.router.navigate(['/dashboard']).then((_)=>{
                            if (isPlatformBrowser(this.platformId)) {
                                localStorage.setItem('ON_STRIPE_CHECKOUT_SUCCESS', JSON.stringify(this.stripeCheckout));
                                window.location.reload();
                            }
                        });
                    } else { this.notificationsService.showNotification(this.transloco.translate('stripeConnect.error'), response.ResponseMessage, NotificationTypes.Error); }
                    this.spinnerService.hide();
                }, error => { console.error(error); this.spinnerService.hide(); this.notificationsService.showNotification(this.transloco.translate('stripeConnect.error'), error, NotificationTypes.Error); });
            } else {
                //since the sessionId is not returned, redirect the user to the home page
                this.router.navigate(['/']);
            }
        });
    }

    constructor(@Inject(PLATFORM_ID) readonly platformId: Object,private activatedRoute: ActivatedRoute,
        private router: Router,
        private notificationsService: NotificationsService,
        private spinnerService: NgxSpinnerService,
        private stripeService: StripeService,
        private authService: AuthService,
        private transloco: TranslocoService) { }
}